const countries = [
    {
        alpha2: 'AC',
        alpha3: '',
        countryCallingCodes: ['+247'],
        emoji: '',
        name: 'Ascension Island',
    },
    {
        alpha2: 'AD',
        alpha3: 'AND',
        countryCallingCodes: ['+376'],
        emoji: '🇦🇩',
        name: 'Andorra',
    },
    {
        alpha2: 'AE',
        alpha3: 'ARE',
        countryCallingCodes: ['+971'],
        emoji: '🇦🇪',
        name: 'United Arab Emirates',
    },
    {
        alpha2: 'AF',
        alpha3: 'AFG',
        countryCallingCodes: ['+93'],
        emoji: '🇦🇫',
        name: 'Afghanistan',
    },
    {
        alpha2: 'AG',
        alpha3: 'ATG',
        countryCallingCodes: ['+1 268'],
        emoji: '🇦🇬',
        name: 'Antigua And Barbuda',
    },
    {
        alpha2: 'AI',
        alpha3: 'AIA',
        countryCallingCodes: ['+1 264'],
        emoji: '🇦🇮',
        name: 'Anguilla',
    },
    {
        alpha2: 'AL',
        alpha3: 'ALB',
        countryCallingCodes: ['+355'],
        emoji: '🇦🇱',
        name: 'Albania',
    },
    {
        alpha2: 'AM',
        alpha3: 'ARM',
        countryCallingCodes: ['+374'],
        emoji: '🇦🇲',
        name: 'Armenia',
    },
    {
        alpha2: 'AO',
        alpha3: 'AGO',
        countryCallingCodes: ['+244'],
        emoji: '🇦🇴',
        name: 'Angola',
    },
    {
        alpha2: 'AQ',
        alpha3: 'ATA',
        countryCallingCodes: ['+672'],
        emoji: '🇦🇶',
        name: 'Antarctica',
    },
    {
        alpha2: 'AR',
        alpha3: 'ARG',
        countryCallingCodes: ['+54'],
        emoji: '🇦🇷',
        name: 'Argentina',
    },
    {
        alpha2: 'AS',
        alpha3: 'ASM',
        countryCallingCodes: ['+1 684'],
        emoji: '🇦🇸',
        name: 'American Samoa',
    },
    {
        alpha2: 'AT',
        alpha3: 'AUT',
        countryCallingCodes: ['+43'],
        emoji: '🇦🇹',
        name: 'Austria',
    },
    {
        alpha2: 'AU',
        alpha3: 'AUS',
        countryCallingCodes: ['+61'],
        emoji: '🇦🇺',
        name: 'Australia',
    },
    {
        alpha2: 'AW',
        alpha3: 'ABW',
        countryCallingCodes: ['+297'],
        emoji: '🇦🇼',
        name: 'Aruba',
    },
    {
        alpha2: 'AX',
        alpha3: 'ALA',
        countryCallingCodes: ['+358'],
        emoji: '🇦🇽',
        name: 'Åland Islands',
    },
    {
        alpha2: 'AZ',
        alpha3: 'AZE',
        countryCallingCodes: ['+994'],
        emoji: '🇦🇿',
        name: 'Azerbaijan',
    },
    {
        alpha2: 'BA',
        alpha3: 'BIH',
        countryCallingCodes: ['+387'],
        emoji: '🇧🇦',
        name: 'Bosnia & Herzegovina',
    },
    {
        alpha2: 'BB',
        alpha3: 'BRB',
        countryCallingCodes: ['+1 246'],
        emoji: '🇧🇧',
        name: 'Barbados',
    },
    {
        alpha2: 'BD',
        alpha3: 'BGD',
        countryCallingCodes: ['+880'],
        emoji: '🇧🇩',
        name: 'Bangladesh',
    },
    {
        alpha2: 'BE',
        alpha3: 'BEL',
        countryCallingCodes: ['+32'],
        emoji: '🇧🇪',
        name: 'Belgium',
    },
    {
        alpha2: 'BF',
        alpha3: 'BFA',
        countryCallingCodes: ['+226'],
        emoji: '🇧🇫',
        name: 'Burkina Faso',
    },
    {
        alpha2: 'BG',
        alpha3: 'BGR',
        countryCallingCodes: ['+359'],
        emoji: '🇧🇬',
        name: 'Bulgaria',
    },
    {
        alpha2: 'BH',
        alpha3: 'BHR',
        countryCallingCodes: ['+973'],
        emoji: '🇧🇭',
        name: 'Bahrain',
    },
    {
        alpha2: 'BI',
        alpha3: 'BDI',
        countryCallingCodes: ['+257'],
        emoji: '🇧🇮',
        name: 'Burundi',
    },
    {
        alpha2: 'BJ',
        alpha3: 'BEN',
        countryCallingCodes: ['+229'],
        emoji: '🇧🇯',
        name: 'Benin',
    },
    {
        alpha2: 'BL',
        alpha3: 'BLM',
        countryCallingCodes: ['+590'],
        emoji: '🇧🇱',
        name: 'Saint Barthélemy',
    },
    {
        alpha2: 'BM',
        alpha3: 'BMU',
        countryCallingCodes: ['+1 441'],
        emoji: '🇧🇲',
        name: 'Bermuda',
    },
    {
        alpha2: 'BN',
        alpha3: 'BRN',
        countryCallingCodes: ['+673'],
        emoji: '🇧🇳',
        name: 'Brunei Darussalam',
    },
    {
        alpha2: 'BO',
        alpha3: 'BOL',
        countryCallingCodes: ['+591'],
        emoji: '🇧🇴',
        name: 'Bolivia, Plurinational State Of',
    },
    {
        alpha2: 'BQ',
        alpha3: 'BES',
        countryCallingCodes: ['+599'],
        emoji: '🇧🇶',
        name: 'Bonaire, Saint Eustatius And Saba',
    },
    {
        alpha2: 'BR',
        alpha3: 'BRA',
        countryCallingCodes: ['+55'],
        emoji: '🇧🇷',
        name: 'Brazil',
    },
    {
        alpha2: 'BS',
        alpha3: 'BHS',
        countryCallingCodes: ['+1 242'],
        emoji: '🇧🇸',
        name: 'Bahamas',
    },
    {
        alpha2: 'BT',
        alpha3: 'BTN',
        countryCallingCodes: ['+975'],
        emoji: '🇧🇹',
        name: 'Bhutan',
    },
    {
        alpha2: 'BW',
        alpha3: 'BWA',
        countryCallingCodes: ['+267'],
        emoji: '🇧🇼',
        name: 'Botswana',
    },
    {
        alpha2: 'BY',
        alpha3: 'BLR',
        countryCallingCodes: ['+375'],
        emoji: '🇧🇾',
        name: 'Belarus',
    },
    {
        alpha2: 'BZ',
        alpha3: 'BLZ',
        countryCallingCodes: ['+501'],
        emoji: '🇧🇿',
        name: 'Belize',
    },
    {
        alpha2: 'CA',
        alpha3: 'CAN',
        countryCallingCodes: ['+1'],
        emoji: '🇨🇦',
        name: 'Canada',
    },
    {
        alpha2: 'CC',
        alpha3: 'CCK',
        countryCallingCodes: ['+61'],
        emoji: '🇨🇨',
        name: 'Cocos (Keeling) Islands',
    },
    {
        alpha2: 'CD',
        alpha3: 'COD',
        countryCallingCodes: ['+243'],
        emoji: '🇨🇩',
        name: 'Democratic Republic Of Congo',
    },
    {
        alpha2: 'CF',
        alpha3: 'CAF',
        countryCallingCodes: ['+236'],
        emoji: '🇨🇫',
        name: 'Central African Republic',
    },
    {
        alpha2: 'CG',
        alpha3: 'COG',
        countryCallingCodes: ['+242'],
        emoji: '🇨🇬',
        name: 'Republic Of Congo',
    },
    {
        alpha2: 'CH',
        alpha3: 'CHE',
        countryCallingCodes: ['+41'],
        emoji: '🇨🇭',
        name: 'Switzerland',
    },
    {
        alpha2: 'CI',
        alpha3: 'CIV',
        countryCallingCodes: ['+225'],
        emoji: '🇨🇮',
        name: "Côte d'Ivoire",
    },
    {
        alpha2: 'CK',
        alpha3: 'COK',
        countryCallingCodes: ['+682'],
        emoji: '🇨🇰',
        name: 'Cook Islands',
    },
    {
        alpha2: 'CL',
        alpha3: 'CHL',
        countryCallingCodes: ['+56'],
        emoji: '🇨🇱',
        name: 'Chile',
    },
    {
        alpha2: 'CM',
        alpha3: 'CMR',
        countryCallingCodes: ['+237'],
        emoji: '🇨🇲',
        name: 'Cameroon',
    },
    {
        alpha2: 'CN',
        alpha3: 'CHN',
        countryCallingCodes: ['+86'],
        emoji: '🇨🇳',
        name: 'China',
    },
    {
        alpha2: 'CO',
        alpha3: 'COL',
        countryCallingCodes: ['+57'],
        emoji: '🇨🇴',
        name: 'Colombia',
    },
    {
        alpha2: 'CR',
        alpha3: 'CRI',
        countryCallingCodes: ['+506'],
        emoji: '🇨🇷',
        name: 'Costa Rica',
    },
    {
        alpha2: 'CU',
        alpha3: 'CUB',
        countryCallingCodes: ['+53'],
        emoji: '🇨🇺',
        name: 'Cuba',
    },
    {
        alpha2: 'CV',
        alpha3: 'CPV',
        countryCallingCodes: ['+238'],
        emoji: '🇨🇻',
        name: 'Cabo Verde',
    },
    {
        alpha2: 'CW',
        alpha3: 'CUW',
        countryCallingCodes: ['+599'],
        emoji: '🇨🇼',
        name: 'Curacao',
    },
    {
        alpha2: 'CX',
        alpha3: 'CXR',
        countryCallingCodes: ['+61'],
        emoji: '🇨🇽',
        name: 'Christmas Island',
    },
    {
        alpha2: 'CY',
        alpha3: 'CYP',
        countryCallingCodes: ['+357'],
        emoji: '🇨🇾',
        name: 'Cyprus',
    },
    {
        alpha2: 'CZ',
        alpha3: 'CZE',
        countryCallingCodes: ['+420'],
        emoji: '🇨🇿',
        name: 'Czech Republic',
    },
    {
        alpha2: 'DE',
        alpha3: 'DEU',
        countryCallingCodes: ['+49'],
        emoji: '🇩🇪',
        name: 'Germany',
    },
    {
        alpha2: 'DJ',
        alpha3: 'DJI',
        countryCallingCodes: ['+253'],
        emoji: '🇩🇯',
        name: 'Djibouti',
    },
    {
        alpha2: 'DK',
        alpha3: 'DNK',
        countryCallingCodes: ['+45'],
        emoji: '🇩🇰',
        name: 'Denmark',
    },
    {
        alpha2: 'DM',
        alpha3: 'DMA',
        countryCallingCodes: ['+1 767'],
        emoji: '🇩🇲',
        name: 'Dominica',
    },
    {
        alpha2: 'DO',
        alpha3: 'DOM',
        countryCallingCodes: ['+1 809', '+1 829', '+1 849'],
        emoji: '🇩🇴',
        name: 'Dominican Republic',
    },
    {
        alpha2: 'DZ',
        alpha3: 'DZA',
        countryCallingCodes: ['+213'],
        emoji: '🇩🇿',
        name: 'Algeria',
    },
    {
        alpha2: 'EC',
        alpha3: 'ECU',
        countryCallingCodes: ['+593'],
        emoji: '🇪🇨',
        name: 'Ecuador',
    },
    {
        alpha2: 'EE',
        alpha3: 'EST',
        countryCallingCodes: ['+372'],
        emoji: '🇪🇪',
        name: 'Estonia',
    },
    {
        alpha2: 'EG',
        alpha3: 'EGY',
        countryCallingCodes: ['+20'],
        emoji: '🇪🇬',
        name: 'Egypt',
    },
    {
        alpha2: 'EH',
        alpha3: 'ESH',
        countryCallingCodes: ['+212'],
        emoji: '🇪🇭',
        name: 'Western Sahara',
    },
    {
        alpha2: 'ER',
        alpha3: 'ERI',
        countryCallingCodes: ['+291'],
        emoji: '🇪🇷',
        name: 'Eritrea',
    },
    {
        alpha2: 'ES',
        alpha3: 'ESP',
        countryCallingCodes: ['+34'],
        emoji: '🇪🇸',
        name: 'Spain',
    },
    {
        alpha2: 'ET',
        alpha3: 'ETH',
        countryCallingCodes: ['+251'],
        emoji: '🇪🇹',
        name: 'Ethiopia',
    },
    {
        alpha2: 'EU',
        alpha3: '',
        countryCallingCodes: ['+388'],
        emoji: '🇪🇺',
        name: 'European Union',
    },
    {
        alpha2: 'FI',
        alpha3: 'FIN',
        countryCallingCodes: ['+358'],
        emoji: '🇫🇮',
        name: 'Finland',
    },
    {
        alpha2: 'FJ',
        alpha3: 'FJI',
        countryCallingCodes: ['+679'],
        emoji: '🇫🇯',
        name: 'Fiji',
    },
    {
        alpha2: 'FK',
        alpha3: 'FLK',
        countryCallingCodes: ['+500'],
        emoji: '🇫🇰',
        name: 'Falkland Islands',
    },
    {
        alpha2: 'FM',
        alpha3: 'FSM',
        countryCallingCodes: ['+691'],
        emoji: '🇫🇲',
        name: 'Micronesia, Federated States Of',
    },
    {
        alpha2: 'FO',
        alpha3: 'FRO',
        countryCallingCodes: ['+298'],
        emoji: '🇫🇴',
        name: 'Faroe Islands',
    },
    {
        alpha2: 'FR',
        alpha3: 'FRA',
        countryCallingCodes: ['+33'],
        emoji: '🇫🇷',
        name: 'France',
    },
    {
        alpha2: 'FX',
        alpha3: '',
        countryCallingCodes: ['+241'],
        emoji: '',
        name: 'France, Metropolitan',
    },
    {
        alpha2: 'GA',
        alpha3: 'GAB',
        countryCallingCodes: ['+241'],
        emoji: '🇬🇦',
        name: 'Gabon',
    },
    {
        alpha2: 'GB',
        alpha3: 'GBR',
        countryCallingCodes: ['+44'],
        emoji: '🇬🇧',
        name: 'United Kingdom',
    },
    {
        alpha2: 'GD',
        alpha3: 'GRD',
        countryCallingCodes: ['+473'],
        emoji: '🇬🇩',
        name: 'Grenada',
    },
    {
        alpha2: 'GE',
        alpha3: 'GEO',
        countryCallingCodes: ['+995'],
        emoji: '🇬🇪',
        name: 'Georgia',
    },
    {
        alpha2: 'GF',
        alpha3: 'GUF',
        countryCallingCodes: ['+594'],
        emoji: '🇬🇫',
        name: 'French Guiana',
    },
    {
        alpha2: 'GG',
        alpha3: 'GGY',
        countryCallingCodes: ['+44'],
        emoji: '🇬🇬',
        name: 'Guernsey',
    },
    {
        alpha2: 'GH',
        alpha3: 'GHA',
        countryCallingCodes: ['+233'],
        emoji: '🇬🇭',
        name: 'Ghana',
    },
    {
        alpha2: 'GI',
        alpha3: 'GIB',
        countryCallingCodes: ['+350'],
        emoji: '🇬🇮',
        name: 'Gibraltar',
    },
    {
        alpha2: 'GL',
        alpha3: 'GRL',
        countryCallingCodes: ['+299'],
        emoji: '🇬🇱',
        name: 'Greenland',
    },
    {
        alpha2: 'GM',
        alpha3: 'GMB',
        countryCallingCodes: ['+220'],
        emoji: '🇬🇲',
        name: 'Gambia',
    },
    {
        alpha2: 'GN',
        alpha3: 'GIN',
        countryCallingCodes: ['+224'],
        emoji: '🇬🇳',
        name: 'Guinea',
    },
    {
        alpha2: 'GP',
        alpha3: 'GLP',
        countryCallingCodes: ['+590'],
        emoji: '🇬🇵',
        name: 'Guadeloupe',
    },
    {
        alpha2: 'GQ',
        alpha3: 'GNQ',
        countryCallingCodes: ['+240'],
        emoji: '🇬🇶',
        name: 'Equatorial Guinea',
    },
    {
        alpha2: 'GR',
        alpha3: 'GRC',
        countryCallingCodes: ['+30'],
        emoji: '🇬🇷',
        name: 'Greece',
    },
    {
        alpha2: 'GT',
        alpha3: 'GTM',
        countryCallingCodes: ['+502'],
        emoji: '🇬🇹',
        name: 'Guatemala',
    },
    {
        alpha2: 'GU',
        alpha3: 'GUM',
        countryCallingCodes: ['+1 671'],
        emoji: '🇬🇺',
        name: 'Guam',
    },
    {
        alpha2: 'GW',
        alpha3: 'GNB',
        countryCallingCodes: ['+245'],
        emoji: '🇬🇼',
        name: 'Guinea-bissau',
    },
    {
        alpha2: 'GY',
        alpha3: 'GUY',
        countryCallingCodes: ['+592'],
        emoji: '🇬🇾',
        name: 'Guyana',
    },
    {
        alpha2: 'HK',
        alpha3: 'HKG',
        countryCallingCodes: ['+852'],
        emoji: '🇭🇰',
        name: 'Hong Kong',
    },
    {
        alpha2: 'HN',
        alpha3: 'HND',
        countryCallingCodes: ['+504'],
        emoji: '🇭🇳',
        name: 'Honduras',
    },
    {
        alpha2: 'HR',
        alpha3: 'HRV',
        countryCallingCodes: ['+385'],
        emoji: '🇭🇷',
        name: 'Croatia',
    },
    {
        alpha2: 'HT',
        alpha3: 'HTI',
        countryCallingCodes: ['+509'],
        emoji: '🇭🇹',
        name: 'Haiti',
    },
    {
        alpha2: 'HU',
        alpha3: 'HUN',
        countryCallingCodes: ['+36'],
        emoji: '🇭🇺',
        name: 'Hungary',
    },
    {
        alpha2: 'ID',
        alpha3: 'IDN',
        countryCallingCodes: ['+62'],
        emoji: '🇮🇩',
        name: 'Indonesia',
    },
    {
        alpha2: 'IE',
        alpha3: 'IRL',
        countryCallingCodes: ['+353'],
        emoji: '🇮🇪',
        name: 'Ireland',
    },
    {
        alpha2: 'IL',
        alpha3: 'ISR',
        countryCallingCodes: ['+972'],
        emoji: '🇮🇱',
        name: 'Israel',
    },
    {
        alpha2: 'IM',
        alpha3: 'IMN',
        countryCallingCodes: ['+44'],
        emoji: '🇮🇲',
        name: 'Isle Of Man',
    },
    {
        alpha2: 'IN',
        alpha3: 'IND',
        countryCallingCodes: ['+91'],
        emoji: '🇮🇳',
        name: 'India',
    },
    {
        alpha2: 'IO',
        alpha3: 'IOT',
        countryCallingCodes: ['+246'],
        emoji: '🇮🇴',
        name: 'British Indian Ocean Territory',
    },
    {
        alpha2: 'IQ',
        alpha3: 'IRQ',
        countryCallingCodes: ['+964'],
        emoji: '🇮🇶',
        name: 'Iraq',
    },
    {
        alpha2: 'IR',
        alpha3: 'IRN',
        countryCallingCodes: ['+98'],
        emoji: '🇮🇷',
        name: 'Iran, Islamic Republic Of',
    },
    {
        alpha2: 'IS',
        alpha3: 'ISL',
        countryCallingCodes: ['+354'],
        emoji: '🇮🇸',
        name: 'Iceland',
    },
    {
        alpha2: 'IT',
        alpha3: 'ITA',
        countryCallingCodes: ['+39'],
        emoji: '🇮🇹',
        name: 'Italy',
    },
    {
        alpha2: 'JE',
        alpha3: 'JEY',
        countryCallingCodes: ['+44'],
        emoji: '🇯🇪',
        name: 'Jersey',
    },
    {
        alpha2: 'JM',
        alpha3: 'JAM',
        countryCallingCodes: ['+1 876'],
        emoji: '🇯🇲',
        name: 'Jamaica',
    },
    {
        alpha2: 'JO',
        alpha3: 'JOR',
        countryCallingCodes: ['+962'],
        emoji: '🇯🇴',
        name: 'Jordan',
    },
    {
        alpha2: 'JP',
        alpha3: 'JPN',
        countryCallingCodes: ['+81'],
        emoji: '🇯🇵',
        name: 'Japan',
    },
    {
        alpha2: 'KE',
        alpha3: 'KEN',
        countryCallingCodes: ['+254'],
        emoji: '🇰🇪',
        name: 'Kenya',
    },
    {
        alpha2: 'KG',
        alpha3: 'KGZ',
        countryCallingCodes: ['+996'],
        emoji: '🇰🇬',
        name: 'Kyrgyzstan',
    },
    {
        alpha2: 'KH',
        alpha3: 'KHM',
        countryCallingCodes: ['+855'],
        emoji: '🇰🇭',
        name: 'Cambodia',
    },
    {
        alpha2: 'KI',
        alpha3: 'KIR',
        countryCallingCodes: ['+686'],
        emoji: '🇰🇮',
        name: 'Kiribati',
    },
    {
        alpha2: 'KM',
        alpha3: 'COM',
        countryCallingCodes: ['+269'],
        emoji: '🇰🇲',
        name: 'Comoros',
    },
    {
        alpha2: 'KN',
        alpha3: 'KNA',
        countryCallingCodes: ['+1 869'],
        emoji: '🇰🇳',
        name: 'Saint Kitts And Nevis',
    },
    {
        alpha2: 'KP',
        alpha3: 'PRK',
        countryCallingCodes: ['+850'],
        emoji: '🇰🇵',
        name: "Korea, Democratic People's Republic Of",
    },
    {
        alpha2: 'KR',
        alpha3: 'KOR',
        countryCallingCodes: ['+82'],
        emoji: '🇰🇷',
        name: 'Korea, Republic Of',
    },
    {
        alpha2: 'KW',
        alpha3: 'KWT',
        countryCallingCodes: ['+965'],
        emoji: '🇰🇼',
        name: 'Kuwait',
    },
    {
        alpha2: 'KY',
        alpha3: 'CYM',
        countryCallingCodes: ['+1 345'],
        emoji: '🇰🇾',
        name: 'Cayman Islands',
    },
    {
        alpha2: 'KZ',
        alpha3: 'KAZ',
        countryCallingCodes: ['+7', '+7 6', '+7 7'],
        emoji: '🇰🇿',
        name: 'Kazakhstan',
    },
    {
        alpha2: 'LA',
        alpha3: 'LAO',
        countryCallingCodes: ['+856'],
        emoji: '🇱🇦',
        name: "Lao People's Democratic Republic",
    },
    {
        alpha2: 'LB',
        alpha3: 'LBN',
        countryCallingCodes: ['+961'],
        emoji: '🇱🇧',
        name: 'Lebanon',
    },
    {
        alpha2: 'LC',
        alpha3: 'LCA',
        countryCallingCodes: ['+1 758'],
        emoji: '🇱🇨',
        name: 'Saint Lucia',
    },
    {
        alpha2: 'LI',
        alpha3: 'LIE',
        countryCallingCodes: ['+423'],
        emoji: '🇱🇮',
        name: 'Liechtenstein',
    },
    {
        alpha2: 'LK',
        alpha3: 'LKA',
        countryCallingCodes: ['+94'],
        emoji: '🇱🇰',
        name: 'Sri Lanka',
    },
    {
        alpha2: 'LR',
        alpha3: 'LBR',
        countryCallingCodes: ['+231'],
        emoji: '🇱🇷',
        name: 'Liberia',
    },
    {
        alpha2: 'LS',
        alpha3: 'LSO',
        countryCallingCodes: ['+266'],
        emoji: '🇱🇸',
        name: 'Lesotho',
    },
    {
        alpha2: 'LT',
        alpha3: 'LTU',
        countryCallingCodes: ['+370'],
        emoji: '🇱🇹',
        name: 'Lithuania',
    },
    {
        alpha2: 'LU',
        alpha3: 'LUX',
        countryCallingCodes: ['+352'],
        emoji: '🇱🇺',
        name: 'Luxembourg',
    },
    {
        alpha2: 'LV',
        alpha3: 'LVA',
        countryCallingCodes: ['+371'],
        emoji: '🇱🇻',
        name: 'Latvia',
    },
    {
        alpha2: 'LY',
        alpha3: 'LBY',
        countryCallingCodes: ['+218'],
        emoji: '🇱🇾',
        name: 'Libya',
    },
    {
        alpha2: 'MA',
        alpha3: 'MAR',
        countryCallingCodes: ['+212'],
        emoji: '🇲🇦',
        name: 'Morocco',
    },
    {
        alpha2: 'MC',
        alpha3: 'MCO',
        countryCallingCodes: ['+377'],
        emoji: '🇲🇨',
        name: 'Monaco',
    },
    {
        alpha2: 'MD',
        alpha3: 'MDA',
        countryCallingCodes: ['+373'],
        emoji: '🇲🇩',
        name: 'Moldova',
    },
    {
        alpha2: 'ME',
        alpha3: 'MNE',
        countryCallingCodes: ['+382'],
        emoji: '🇲🇪',
        name: 'Montenegro',
    },
    {
        alpha2: 'MF',
        alpha3: 'MAF',
        countryCallingCodes: ['+590'],
        emoji: '🇲🇫',
        name: 'Saint Martin',
    },
    {
        alpha2: 'MG',
        alpha3: 'MDG',
        countryCallingCodes: ['+261'],
        emoji: '🇲🇬',
        name: 'Madagascar',
    },
    {
        alpha2: 'MH',
        alpha3: 'MHL',
        countryCallingCodes: ['+692'],
        emoji: '🇲🇭',
        name: 'Marshall Islands',
    },
    {
        alpha2: 'MK',
        alpha3: 'MKD',
        countryCallingCodes: ['+389'],
        emoji: '🇲🇰',
        name: 'Macedonia, The Former Yugoslav Republic Of',
    },
    {
        alpha2: 'ML',
        alpha3: 'MLI',
        countryCallingCodes: ['+223'],
        emoji: '🇲🇱',
        name: 'Mali',
    },
    {
        alpha2: 'MM',
        alpha3: 'MMR',
        countryCallingCodes: ['+95'],
        emoji: '🇲🇲',
        name: 'Myanmar',
    },
    {
        alpha2: 'MN',
        alpha3: 'MNG',
        countryCallingCodes: ['+976'],
        emoji: '🇲🇳',
        name: 'Mongolia',
    },
    {
        alpha2: 'MO',
        alpha3: 'MAC',
        countryCallingCodes: ['+853'],
        emoji: '🇲🇴',
        name: 'Macao',
    },
    {
        alpha2: 'MP',
        alpha3: 'MNP',
        countryCallingCodes: ['+1 670'],
        emoji: '🇲🇵',
        name: 'Northern Mariana Islands',
    },
    {
        alpha2: 'MQ',
        alpha3: 'MTQ',
        countryCallingCodes: ['+596'],
        emoji: '🇲🇶',
        name: 'Martinique',
    },
    {
        alpha2: 'MR',
        alpha3: 'MRT',
        countryCallingCodes: ['+222'],
        emoji: '🇲🇷',
        name: 'Mauritania',
    },
    {
        alpha2: 'MS',
        alpha3: 'MSR',
        countryCallingCodes: ['+1 664'],
        emoji: '🇲🇸',
        name: 'Montserrat',
    },
    {
        alpha2: 'MT',
        alpha3: 'MLT',
        countryCallingCodes: ['+356'],
        emoji: '🇲🇹',
        name: 'Malta',
    },
    {
        alpha2: 'MU',
        alpha3: 'MUS',
        countryCallingCodes: ['+230'],
        emoji: '🇲🇺',
        name: 'Mauritius',
    },
    {
        alpha2: 'MV',
        alpha3: 'MDV',
        countryCallingCodes: ['+960'],
        emoji: '🇲🇻',
        name: 'Maldives',
    },
    {
        alpha2: 'MW',
        alpha3: 'MWI',
        countryCallingCodes: ['+265'],
        emoji: '🇲🇼',
        name: 'Malawi',
    },
    {
        alpha2: 'MX',
        alpha3: 'MEX',
        countryCallingCodes: ['+52'],
        emoji: '🇲🇽',
        name: 'Mexico',
    },
    {
        alpha2: 'MY',
        alpha3: 'MYS',
        countryCallingCodes: ['+60'],
        emoji: '🇲🇾',
        name: 'Malaysia',
    },
    {
        alpha2: 'MZ',
        alpha3: 'MOZ',
        countryCallingCodes: ['+258'],
        emoji: '🇲🇿',
        name: 'Mozambique',
    },
    {
        alpha2: 'NA',
        alpha3: 'NAM',
        countryCallingCodes: ['+264'],
        emoji: '🇳🇦',
        name: 'Namibia',
    },
    {
        alpha2: 'NC',
        alpha3: 'NCL',
        countryCallingCodes: ['+687'],
        emoji: '🇳🇨',
        name: 'New Caledonia',
    },
    {
        alpha2: 'NE',
        alpha3: 'NER',
        countryCallingCodes: ['+227'],
        emoji: '🇳🇪',
        name: 'Niger',
    },
    {
        alpha2: 'NF',
        alpha3: 'NFK',
        countryCallingCodes: ['+672'],
        emoji: '🇳🇫',
        name: 'Norfolk Island',
    },
    {
        alpha2: 'NG',
        alpha3: 'NGA',
        countryCallingCodes: ['+234'],
        emoji: '🇳🇬',
        name: 'Nigeria',
    },
    {
        alpha2: 'NI',
        alpha3: 'NIC',
        countryCallingCodes: ['+505'],
        emoji: '🇳🇮',
        name: 'Nicaragua',
    },
    {
        alpha2: 'NL',
        alpha3: 'NLD',
        countryCallingCodes: ['+31'],
        emoji: '🇳🇱',
        name: 'Netherlands',
    },
    {
        alpha2: 'NO',
        alpha3: 'NOR',
        countryCallingCodes: ['+47'],
        emoji: '🇳🇴',
        name: 'Norway',
    },
    {
        alpha2: 'NP',
        alpha3: 'NPL',
        countryCallingCodes: ['+977'],
        emoji: '🇳🇵',
        name: 'Nepal',
    },
    {
        alpha2: 'NR',
        alpha3: 'NRU',
        countryCallingCodes: ['+674'],
        emoji: '🇳🇷',
        name: 'Nauru',
    },
    {
        alpha2: 'NU',
        alpha3: 'NIU',
        countryCallingCodes: ['+683'],
        emoji: '🇳🇺',
        name: 'Niue',
    },
    {
        alpha2: 'NZ',
        alpha3: 'NZL',
        countryCallingCodes: ['+64'],
        emoji: '🇳🇿',
        name: 'New Zealand',
    },
    {
        alpha2: 'OM',
        alpha3: 'OMN',
        countryCallingCodes: ['+968'],
        emoji: '🇴🇲',
        name: 'Oman',
    },
    {
        alpha2: 'PA',
        alpha3: 'PAN',
        countryCallingCodes: ['+507'],
        emoji: '🇵🇦',
        name: 'Panama',
    },
    {
        alpha2: 'PE',
        alpha3: 'PER',
        countryCallingCodes: ['+51'],
        emoji: '🇵🇪',
        name: 'Peru',
    },
    {
        alpha2: 'PF',
        alpha3: 'PYF',
        countryCallingCodes: ['+689'],
        emoji: '🇵🇫',
        name: 'French Polynesia',
    },
    {
        alpha2: 'PG',
        alpha3: 'PNG',
        countryCallingCodes: ['+675'],
        emoji: '🇵🇬',
        name: 'Papua New Guinea',
    },
    {
        alpha2: 'PH',
        alpha3: 'PHL',
        countryCallingCodes: ['+63'],
        emoji: '🇵🇭',
        name: 'Philippines',
    },
    {
        alpha2: 'PK',
        alpha3: 'PAK',
        countryCallingCodes: ['+92'],
        emoji: '🇵🇰',
        name: 'Pakistan',
    },
    {
        alpha2: 'PL',
        alpha3: 'POL',
        countryCallingCodes: ['+48'],
        emoji: '🇵🇱',
        name: 'Poland',
    },
    {
        alpha2: 'PM',
        alpha3: 'SPM',
        countryCallingCodes: ['+508'],
        emoji: '🇵🇲',
        name: 'Saint Pierre And Miquelon',
    },
    {
        alpha2: 'PN',
        alpha3: 'PCN',
        countryCallingCodes: ['+872'],
        emoji: '🇵🇳',
        name: 'Pitcairn',
    },
    {
        alpha2: 'PR',
        alpha3: 'PRI',
        countryCallingCodes: ['+1 787', '+1 939'],
        emoji: '🇵🇷',
        name: 'Puerto Rico',
    },
    {
        alpha2: 'PS',
        alpha3: 'PSE',
        countryCallingCodes: ['+970'],
        emoji: '🇵🇸',
        name: 'Palestinian Territory, Occupied',
    },
    {
        alpha2: 'PT',
        alpha3: 'PRT',
        countryCallingCodes: ['+351'],
        emoji: '🇵🇹',
        name: 'Portugal',
    },
    {
        alpha2: 'PW',
        alpha3: 'PLW',
        countryCallingCodes: ['+680'],
        emoji: '🇵🇼',
        name: 'Palau',
    },
    {
        alpha2: 'PY',
        alpha3: 'PRY',
        countryCallingCodes: ['+595'],
        emoji: '🇵🇾',
        name: 'Paraguay',
    },
    {
        alpha2: 'QA',
        alpha3: 'QAT',
        countryCallingCodes: ['+974'],
        emoji: '🇶🇦',
        name: 'Qatar',
    },
    {
        alpha2: 'RE',
        alpha3: 'REU',
        countryCallingCodes: ['+262'],
        emoji: '🇷🇪',
        name: 'Reunion',
    },
    {
        alpha2: 'RO',
        alpha3: 'ROU',
        countryCallingCodes: ['+40'],
        emoji: '🇷🇴',
        name: 'Romania',
    },
    {
        alpha2: 'RS',
        alpha3: 'SRB',
        countryCallingCodes: ['+381'],
        emoji: '🇷🇸',
        name: 'Serbia',
    },
    {
        alpha2: 'RU',
        alpha3: 'RUS',
        countryCallingCodes: ['+7', '+7 3', '+7 4', '+7 8'],
        emoji: '🇷🇺',
        name: 'Russian Federation',
    },
    {
        alpha2: 'RW',
        alpha3: 'RWA',
        countryCallingCodes: ['+250'],
        emoji: '🇷🇼',
        name: 'Rwanda',
    },
    {
        alpha2: 'SA',
        alpha3: 'SAU',
        countryCallingCodes: ['+966'],
        emoji: '🇸🇦',
        name: 'Saudi Arabia',
    },
    {
        alpha2: 'SB',
        alpha3: 'SLB',
        countryCallingCodes: ['+677'],
        emoji: '🇸🇧',
        name: 'Solomon Islands',
    },
    {
        alpha2: 'SC',
        alpha3: 'SYC',
        countryCallingCodes: ['+248'],
        emoji: '🇸🇨',
        name: 'Seychelles',
    },
    {
        alpha2: 'SD',
        alpha3: 'SDN',
        countryCallingCodes: ['+249'],
        emoji: '🇸🇩',
        name: 'Sudan',
    },
    {
        alpha2: 'SE',
        alpha3: 'SWE',
        countryCallingCodes: ['+46'],
        emoji: '🇸🇪',
        name: 'Sweden',
    },
    {
        alpha2: 'SG',
        alpha3: 'SGP',
        countryCallingCodes: ['+65'],
        emoji: '🇸🇬',
        name: 'Singapore',
    },
    {
        alpha2: 'SH',
        alpha3: 'SHN',
        countryCallingCodes: ['+290'],
        emoji: '🇸🇭',
        name: 'Saint Helena, Ascension And Tristan Da Cunha',
    },
    {
        alpha2: 'SI',
        alpha3: 'SVN',
        countryCallingCodes: ['+386'],
        emoji: '🇸🇮',
        name: 'Slovenia',
    },
    {
        alpha2: 'SJ',
        alpha3: 'SJM',
        countryCallingCodes: ['+47'],
        emoji: '🇸🇯',
        name: 'Svalbard And Jan Mayen',
    },
    {
        alpha2: 'SK',
        alpha3: 'SVK',
        countryCallingCodes: ['+421'],
        emoji: '🇸🇰',
        name: 'Slovakia',
    },
    {
        alpha2: 'SL',
        alpha3: 'SLE',
        countryCallingCodes: ['+232'],
        emoji: '🇸🇱',
        name: 'Sierra Leone',
    },
    {
        alpha2: 'SM',
        alpha3: 'SMR',
        countryCallingCodes: ['+378'],
        emoji: '🇸🇲',
        name: 'San Marino',
    },
    {
        alpha2: 'SN',
        alpha3: 'SEN',
        countryCallingCodes: ['+221'],
        emoji: '🇸🇳',
        name: 'Senegal',
    },
    {
        alpha2: 'SO',
        alpha3: 'SOM',
        countryCallingCodes: ['+252'],
        emoji: '🇸🇴',
        name: 'Somalia',
    },
    {
        alpha2: 'SR',
        alpha3: 'SUR',
        countryCallingCodes: ['+597'],
        emoji: '🇸🇷',
        name: 'Suriname',
    },
    {
        alpha2: 'SS',
        alpha3: 'SSD',
        countryCallingCodes: ['+211'],
        emoji: '🇸🇸',
        name: 'South Sudan',
    },
    {
        alpha2: 'ST',
        alpha3: 'STP',
        countryCallingCodes: ['+239'],
        emoji: '🇸🇹',
        name: 'Sao Tome and Principe',
    },
    {
        alpha2: 'SV',
        alpha3: 'SLV',
        countryCallingCodes: ['+503'],
        emoji: '🇸🇻',
        name: 'El Salvador',
    },
    {
        alpha2: 'SX',
        alpha3: 'SXM',
        countryCallingCodes: ['+1 721'],
        emoji: '🇸🇽',
        name: 'Sint Maarten',
    },
    {
        alpha2: 'SY',
        alpha3: 'SYR',
        countryCallingCodes: ['+963'],
        emoji: '🇸🇾',
        name: 'Syrian Arab Republic',
    },
    {
        alpha2: 'SZ',
        alpha3: 'SWZ',
        countryCallingCodes: ['+268'],
        emoji: '🇸🇿',
        name: 'Swaziland',
    },
    {
        alpha2: 'TA',
        alpha3: '',
        countryCallingCodes: ['+290'],
        emoji: '',
        name: 'Tristan de Cunha',
    },
    {
        alpha2: 'TC',
        alpha3: 'TCA',
        countryCallingCodes: ['+1 649'],
        emoji: '🇹🇨',
        name: 'Turks And Caicos Islands',
    },
    {
        alpha2: 'TD',
        alpha3: 'TCD',
        countryCallingCodes: ['+235'],
        emoji: '🇹🇩',
        name: 'Chad',
    },
    {
        alpha2: 'TG',
        alpha3: 'TGO',
        countryCallingCodes: ['+228'],
        emoji: '🇹🇬',
        name: 'Togo',
    },
    {
        alpha2: 'TH',
        alpha3: 'THA',
        countryCallingCodes: ['+66'],
        emoji: '🇹🇭',
        name: 'Thailand',
    },
    {
        alpha2: 'TJ',
        alpha3: 'TJK',
        countryCallingCodes: ['+992'],
        emoji: '🇹🇯',
        name: 'Tajikistan',
    },
    {
        alpha2: 'TK',
        alpha3: 'TKL',
        countryCallingCodes: ['+690'],
        emoji: '🇹🇰',
        name: 'Tokelau',
    },
    {
        alpha2: 'TL',
        alpha3: 'TLS',
        countryCallingCodes: ['+670'],
        emoji: '🇹🇱',
        name: 'Timor-Leste, Democratic Republic of',
    },
    {
        alpha2: 'TM',
        alpha3: 'TKM',
        countryCallingCodes: ['+993'],
        emoji: '🇹🇲',
        name: 'Turkmenistan',
    },
    {
        alpha2: 'TN',
        alpha3: 'TUN',
        countryCallingCodes: ['+216'],
        emoji: '🇹🇳',
        name: 'Tunisia',
    },
    {
        alpha2: 'TO',
        alpha3: 'TON',
        countryCallingCodes: ['+676'],
        emoji: '🇹🇴',
        name: 'Tonga',
    },
    {
        alpha2: 'TR',
        alpha3: 'TUR',
        countryCallingCodes: ['+90'],
        emoji: '🇹🇷',
        name: 'Turkey',
    },
    {
        alpha2: 'TT',
        alpha3: 'TTO',
        countryCallingCodes: ['+1 868'],
        emoji: '🇹🇹',
        name: 'Trinidad And Tobago',
    },
    {
        alpha2: 'TV',
        alpha3: 'TUV',
        countryCallingCodes: ['+688'],
        emoji: '🇹🇻',
        name: 'Tuvalu',
    },
    {
        alpha2: 'TW',
        alpha3: 'TWN',
        countryCallingCodes: ['+886'],
        emoji: '🇹🇼',
        name: 'Taiwan',
    },
    {
        alpha2: 'TZ',
        alpha3: 'TZA',
        countryCallingCodes: ['+255'],
        emoji: '🇹🇿',
        name: 'Tanzania, United Republic Of',
    },
    {
        alpha2: 'UA',
        alpha3: 'UKR',
        countryCallingCodes: ['+380'],
        emoji: '🇺🇦',
        name: 'Ukraine',
    },
    {
        alpha2: 'UG',
        alpha3: 'UGA',
        countryCallingCodes: ['+256'],
        emoji: '🇺🇬',
        name: 'Uganda',
    },
    {
        alpha2: 'UM',
        alpha3: 'UMI',
        countryCallingCodes: ['+1'],
        emoji: '🇺🇲',
        name: 'United States Minor Outlying Islands',
    },
    {
        alpha2: 'US',
        alpha3: 'USA',
        countryCallingCodes: ['+1'],
        emoji: '🇺🇸',
        name: 'United States',
    },
    {
        alpha2: 'UY',
        alpha3: 'URY',
        countryCallingCodes: ['+598'],
        emoji: '🇺🇾',
        name: 'Uruguay',
    },
    {
        alpha2: 'UZ',
        alpha3: 'UZB',
        countryCallingCodes: ['+998'],
        emoji: '🇺🇿',
        name: 'Uzbekistan',
    },
    {
        alpha2: 'VA',
        alpha3: 'VAT',
        countryCallingCodes: ['+379', '+39'],
        emoji: '🇻🇦',
        name: 'Vatican City State',
    },
    {
        alpha2: 'VC',
        alpha3: 'VCT',
        countryCallingCodes: ['+1 784'],
        emoji: '🇻🇨',
        name: 'Saint Vincent And The Grenadines',
    },
    {
        alpha2: 'VE',
        alpha3: 'VEN',
        countryCallingCodes: ['+58'],
        emoji: '🇻🇪',
        name: 'Venezuela, Bolivarian Republic Of',
    },
    {
        alpha2: 'VG',
        alpha3: 'VGB',
        countryCallingCodes: ['+1 284'],
        emoji: '🇻🇬',
        name: 'Virgin Islands (British)',
    },
    {
        alpha2: 'VI',
        alpha3: 'VIR',
        countryCallingCodes: ['+1 340'],
        emoji: '🇻🇮',
        name: 'Virgin Islands (US)',
    },
    {
        alpha2: 'VN',
        alpha3: 'VNM',
        countryCallingCodes: ['+84'],
        emoji: '🇻🇳',
        name: 'Viet Nam',
    },
    {
        alpha2: 'VU',
        alpha3: 'VUT',
        countryCallingCodes: ['+678'],
        emoji: '🇻🇺',
        name: 'Vanuatu',
    },
    {
        alpha2: 'WF',
        alpha3: 'WLF',
        countryCallingCodes: ['+681'],
        emoji: '🇼🇫',
        name: 'Wallis And Futuna',
    },
    {
        alpha2: 'WS',
        alpha3: 'WSM',
        countryCallingCodes: ['+685'],
        emoji: '🇼🇸',
        name: 'Samoa',
    },
    {
        alpha2: 'XK',
        alpha3: '',
        countryCallingCodes: ['+383'],
        emoji: '',
        name: 'Kosovo',
    },
    {
        alpha2: 'YE',
        alpha3: 'YEM',
        countryCallingCodes: ['+967'],
        emoji: '🇾🇪',
        name: 'Yemen',
    },
    {
        alpha2: 'YT',
        alpha3: 'MYT',
        countryCallingCodes: ['+262'],
        emoji: '🇾🇹',
        name: 'Mayotte',
    },
    {
        alpha2: 'ZA',
        alpha3: 'ZAF',
        countryCallingCodes: ['+27'],
        emoji: '🇿🇦',
        name: 'South Africa',
    },
    {
        alpha2: 'ZM',
        alpha3: 'ZMB',
        countryCallingCodes: ['+260'],
        emoji: '🇿🇲',
        name: 'Zambia',
    },
    {
        alpha2: 'ZW',
        alpha3: 'ZWE',
        countryCallingCodes: ['+263'],
        emoji: '🇿🇼',
        name: 'Zimbabwe',
    },
];


export default countries;
